import axios from 'axios'
import Cookies from 'js-cookie';
import store from '../store/index'
// axios.defaults.baseURL = 'http://localhost:8888/';
axios.defaults.baseURL = '/';


export default function setAxios() {
  //请求拦截
  axios.interceptors.request.use(
    config => {
        const token = store.state.token;
        if (Cookies.get('token')) {
        // 将token设置在headers ['Authorization'] 上面
        config.headers['Authorization'] = token;
        // console.log("AuthorizationAuthorization=", `Bearer ${store.state.token}`);
        // console.log("AuthorizationAuthorization=", Cookies.get('token'));
      }
      return config
    }
  )
}